/**
 * FloatingBlock
 */

import Icon from 'components/ui/Icon';
import { FloatingBlockModel } from 'types/block-types';
import { ExtendedLinkModel } from 'types/common';
import clsx from 'clsx';

/** Main description for this component. */
const FloatingBlock = (props: FloatingBlockModel) => {
	const { title, links, contactList } = props;

	return (
		<nav className="floating-block rounded-card" aria-label="Sidebar">
			<h3 className="font-heading font-bold sm:text-h4 text-blue md:text-h2 mb-5 text-center max-w-50 sm:text-left sm:max-w-none">
				{title}
			</h3>
			{links &&
				links.map((item: ExtendedLinkModel) => {
					return (
						<div className="block my-5">
							<a
								className={clsx(
									'w-full block text-p',
									item.active && 'font-bold'
								)}
								href={item.link}
							>
								<Icon
									icon="arrow"
									size={0.75}
									className="mr-2"
									aria-hidden={true}
								/>
								{item.text}
							</a>
						</div>
					);
				})}
			<div className="mt-7.5">
				{contactList &&
					contactList.map((contact) => {
						return (
							<div className="floating-block-contact-list">
								<p className="font-semibold">{contact.text}</p>
								<p>{contact.value}</p>
							</div>
						);
					})}
			</div>
		</nav>
	);
};

export default FloatingBlock;
